import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import React from 'react'
import { coloBlindnessOption, visualAcuityTest } from './formOptions'
import RadioButtonController, { CheckBoxLikeRadio } from '../../../../components/RadioButtonController/RadioButtonController'
import { ParentContainerSection } from '../DiabeticForm'

const VisualAcuityTest = (props) => {
    const { control, errors } = props

    const visualAcuityTestArr=[
        {label:"L", formFieldName:"visual_acuity_left", option: visualAcuityTest },
        {label:"R", formFieldName:"visual_acuity_right", option: visualAcuityTest },
    ]

  return (
    <ParentContainerSection  heading="Section F: Uncorrected Visual Acuity Test">
        <TableContainer component={Paper} sx={{ maxWidth: 350, mb: "1rem" }}>
      <Table sx={{ maxWidth:350 , '& td, & th': { border: '0.5px solid lightgray', padding:"0px" } }} aria-label="visual acuity table">
        <TableHead>
          <TableRow>
            <TableCell  rowSpan={2}></TableCell>
            <TableCell align="center">6/6</TableCell>
            <TableCell align="center">6/9</TableCell>
            <TableCell align="center">6/12</TableCell>
            <TableCell align="center">6/18</TableCell>
            <TableCell align="center">6/24</TableCell>
            <TableCell align="center">6/36</TableCell>
            <TableCell align="center">6/60</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
        {visualAcuityTestArr.map((visualAcuity,index)=>(
            <TableRow key={index}>
            <TableCell align="center" sx={{minWidth:"25px"}}>{visualAcuity.label}</TableCell>
            {visualAcuity.option.map((item, optionInd)=>(
                <TableCell align="center" key={optionInd}>
                <CheckBoxLikeRadio 
                                name={visualAcuity.formFieldName}
                                isRow={true}
                                control={control}
                                errors={errors}
                                options={[item]}
                                isMargin={false}
                                isDisabled={true}
                            />
                            </TableCell>
            ))}
          </TableRow>
        ))}
        </TableBody>
      </Table>
    </TableContainer>
    </ParentContainerSection>
  )
}

export default VisualAcuityTest